import { useCopyToClipboard } from '@gogame/hooks-ts';
import { useScreenMessage } from '@gogame/screens';

export const useCopyLink = () => {
  const { showSuccessMessage } = useScreenMessage();
  const copyToClipboard = useCopyToClipboard();

  return (link, text = 'Link') => {
    copyToClipboard(link);
    showSuccessMessage(`${text} copied to your clipboard`);
  };
};
